import type { RangeKey } from '@dataTypes/dashboard.types'
import type {
  NoShowRateDetailResult,
  NoShowRateOverviewResult,
} from '@services/api/dashboard/no-show-rate.api'
import { getOverviewNoShowLineChart } from '@components/pages/Dashboard/Overview/dashboardOverview.mockData'
import { getOverviewNoShowMetrics } from '@components/pages/Dashboard/Overview/overviewMetrics.mockData'
import {
  getNoShowByProviderRows,
  getNoShowByTimePeriodRows,
  getNoShowChartConfig,
  getNoShowRateKpi,
} from '@pages/Dashboard/NoShowRateDetail/noShowRateDetail.mockData'
import { rangeToPeriod } from '@utils/dashboardFinance.util'

export function buildNoShowRateOverviewFromMock(
  range: RangeKey,
): NoShowRateOverviewResult {
  const metrics = getOverviewNoShowMetrics(range).map((m) => ({
    id: m.id ?? m.leftLabel,
    leftLabel: m.leftLabel === 'Scheduled today' ? 'Scheduled' : m.leftLabel,
    value: `${m.value}`,
  }))
  const scheduled = metrics.find((m) => m.id === 'ns-scheduled')
  const lost = metrics.find((m) => m.id === 'ns-lost-chair')
  const noShow = metrics.find((m) => m.id === 'ns-no-show')
  const lineChart = getOverviewNoShowLineChart(range)

  return {
    period: rangeToPeriod(range),
    periodStart: '',
    periodEnd: '',
    lostChairTime: lost?.value ? `${lost.value} hrs` : '0 hrs',
    scheduledPct: Number.parseFloat(scheduled?.value ?? '0') || 0,
    scheduledPctDisplay: scheduled?.value ? `${scheduled?.value}%` : '0%',
    noShowCount: Number.parseInt(noShow?.value ?? '0', 10) || 0,
    metrics,
    lineChart,
  }
}

export function buildNoShowRateDetailFromMock(
  range: RangeKey,
): NoShowRateDetailResult {
  const mockKpi = getNoShowRateKpi(range)
  const { openChairTime, noShowRateGoal, ...restKpi } = mockKpi
  return {
    period: rangeToPeriod(range),
    periodStart: '',
    periodEnd: '',
    kpis: {
      ...restKpi,
      lostChairTime: openChairTime,
      noShowRateGoal: noShowRateGoal || null,
    },
    chart: getNoShowChartConfig(range),
    byProvider: getNoShowByProviderRows(range),
    byPeriod: getNoShowByTimePeriodRows(range),
  }
}
